module.exports = __webpack_public_path__ + "img/Admobile3.d86c2ec4.jpg";